module.exports = __webpack_public_path__ + "img/ssyx_27.c5dcb1e7.jpg";